import { DateGranularity } from './DateGranularity';

// EffectiveDefinition holds the lastDataUpdatedAt, schema, features for a metric
export interface EffectiveDefinition {
  readonly schema: Readonly<Schema>;
  readonly features: Readonly<Features>;
  readonly dataRefreshedTimestamp?: string;
}

export type Schema = Record<string, ColumnSchema>;

// tslint:disable-next-line:no-any
export type Features = Record<string, any>;

export type ColumnSchema = NumericColumnSchema | DateTimeColumnSchema | StringColumnSchema | BooleanColumnSchema;

export interface ColumnSchemaSpec {
  readonly type: 'string' | 'number' | 'datetime' | 'boolean';
  readonly displayName?: string;
  readonly name: string;
  readonly calculation?: Calculation;
}

export interface StringColumnSchema extends ColumnSchemaSpec {
  readonly type: 'string';
}

export interface BooleanColumnSchema extends ColumnSchemaSpec {
  readonly type: 'boolean';
}
export interface NumericColumnSchema extends ColumnSchemaSpec {
  readonly type: 'number';
  readonly format?: string;
  readonly tableCalculationInfo?: TableCalculationInfo;
}

export const isNumericColumnSchema = (column?: ColumnSchema): column is NumericColumnSchema => {
  return column !== undefined && column.type === 'number';
};

export interface TableCalculationInfo {
  readonly calculationDescription: string;
}

export interface DateTimeColumnSchema extends ColumnSchemaSpec {
  readonly type: 'datetime';
  readonly format?: string;
  readonly dateGranularity?: DateGranularity;
  readonly fiscalYearStartMonth?: number;
  readonly isSnapshotTimestamp?: boolean;
  readonly isTimeless?: boolean;
}

export const isDateTimeColumnSchema = (column?: ColumnSchema): column is DateTimeColumnSchema => {
  return column !== undefined && column.type === 'datetime';
};

interface TypedPropertyBag {
  readonly type: string;
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

export interface Calculation extends TypedPropertyBag {}

export const TableCalcType = 'table-calc';

export interface TableCalcRef extends Calculation {
  type: typeof TableCalcType;
  tableCalcType: string;
  name: string;
}

export const isTableCalcRef = (calc?: Calculation): calc is TableCalcRef => {
  return calc !== undefined && calc.type === TableCalcType;
};

export type ColumnRefOrValue = ColumnReference | number | string;

export const isColumnRef = (refOrValue: ColumnRefOrValue): refOrValue is ColumnReference => {
  // @ts-ignore
  return refOrValue?.column !== undefined;
};
export interface ColumnReference {
  readonly column: string;
}

export const columnSchemaForRef = (definition: EffectiveDefinition, ref: ColumnReference): ColumnSchema | undefined => {
  return definition.schema[ref.column];
};
